import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    padding: '10px 20px',
    height: 500,
    overflow: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: { padding: '10px 3px' }
  },
  tableHeaderForModal: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 0.5fr 2fr 4fr 4fr 4fr 1fr',
    gridGap: 20,
    color: 'gray',
    alignItems: 'center',
    padding: '4px 4px',
    marginBottom: 4,
    marginTop: 4,
    borderRadius: 8,
    backgroundColor: theme.palette.grey[400]
  },
  tableHeader: { textAlign: 'left' },
  contentWithCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  checkBox: {
    paddingLeft: 0
  },
  noDataImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 400
  }
}))

export default useStyles
